import {api} from '@/http'

// 公司屏蔽列表
const getShieldList = (data, callback, back) => {
  api('/api/shield', 'get', data, callback, back)
}

// 公司屏蔽取消
const companyShieldDel = (id, callback, back) => {
  api('/api/enterprise/' + id + '/shield/', 'del', '', callback, back)
}

// 搜索公司屏蔽
const companyShieldSearch = (data, callback, back) => {
  api('/api/shield/search_enterprise', 'get', data, callback, back)
}

// 新增公司屏蔽
const companyShieldAdd = (id, callback, back) => {
  api('/api/enterprise/' + id + '/shield', 'post', '', callback, back)
}

export default {
  getShieldList,
  companyShieldDel,
  companyShieldSearch,
  companyShieldAdd
}



// WEBPACK FOOTER //
// ./src/api/shield/index.js